interface Props {
  children?: React.ReactNode;
}
export function WorksheetLayout(props: Props) {
  return <div className="WorksheetLayout gap-6">{props.children}</div>;
}
export function WorksheetRow(props: Props) {
  return <div className="WorksheetRow mb-5 flex w-full flex-row gap-6">{props.children}</div>;
}
export function WorksheetColumn(props: Props) {
  return <div className="WorksheetColumn mr-10 mb-5 flex flex-1 flex-col">{props.children}</div>;
}
